<button mat-button class="button-container" (click)="action()?.()">
  <mat-icon class="icon">arrow_back</mat-icon>
  <p class="link-label">{{ label() }}</p>
</button>
